import _ from "lodash";
import { ALWAYS_SCHEDULE, IEditDTO, IEditScheduleDTO, IEditTierDTO, IReferenceDTO } from "../../services/alarm-scheme-data-service/Models";

import { AlarmSchemeNotificationListType, AlarmSchemeScheduledNotificationType, AlarmSchemeTierType } from "../alarm-scheme-tier-card/AlarmSchemeTierUtils";
import Enumerable from "linq";
import { TierFormType } from "./tier-editor/TierEditorUtils";
import { AlarmNotificationTypeEnum } from "../../common/enums/AlarmNotificationTypeEnum";
import i18n from "../../services/localization-service/i18n";

export enum AlarmSchemeAdminMode {
    Add = 0,
    Edit = 1
}

export type AlarmSchemeFormType = {
    //expanded: boolean;
    //notificationLists: IReferenceNotificationListDTO[]
} & IEditDTO;




function _formatTierDescription(form: TierFormType) {

    let description = (form.delayMinutes ?? 0) > 0 ? 
                    i18n.t('alarmSchemeAdmin.tiers.descriptionFormat.beginNotZero', {
                        name: form.name,
                        delayMinutes: form.delayMinutes
                    }) :
                    i18n.t('alarmSchemeAdmin.tiers.descriptionFormat.beginImmediately', {
                        name: form.name,
                    });


    switch(form.type) {

        case AlarmNotificationTypeEnum.Once:
            description = `${description} ${i18n.t('alarmSchemeAdmin.tiers.descriptionFormat.alarmOnce')}`;
            break;

        case AlarmNotificationTypeEnum.EveryXMinutes:
            description = `${description} ${i18n.t('alarmSchemeAdmin.tiers.descriptionFormat.notifyXminutes', {
                name: form.name,
                repeatMinutes: form.repeatMinutes
            })}`;
            break;

        case AlarmNotificationTypeEnum.ZTimesYMinutesApart:
            description = `${description} ${i18n.t('alarmSchemeAdmin.tiers.descriptionFormat.notifyZTimesXMinutes', {
                name: form.name,
                repeatCount: form.repeatZCount,
                repeatMinutes: form.repeatCountMinutes
            })}`;


            break;

    }
    

    return description;

}


// private string _formatTierDescription(AlarmSchemeData.Tier tier)
//         {
//             var description = (tier.NotificationDelayMinutes > 0)

//                 ? string.Format(
//                     Resources.TieredAlarmingFunctionalityModel.AlarmScheme_TierDescription_BeginMinutesNotZero,
//                     tier.Name,
//                     tier.NotificationDelayMinutes)

//                 : string.Format(
//                     Resources.TieredAlarmingFunctionalityModel.AlarmScheme_TierDescription_BeginMinutesIsZero,
//                     tier.Name);

//             switch ((AlarmNotificationTypeEnum)tier.NotificationType)
//             {
//                 case AlarmNotificationTypeEnum.Once:
//                     description = string.Format(
//                         Resources.TieredAlarmingFunctionalityModel.AlarmScheme_TierDescription_NotifyOnce,
//                         description);

//                     break;


//                 case AlarmNotificationTypeEnum.EveryXMinutes:
//                     description = string.Format(
//                         Resources.TieredAlarmingFunctionalityModel.AlarmScheme_TierDescription_NotifyEveryXMinutes,
//                         description,
//                         tier.NotificationRepeatMinutes);

//                     break;


//                 case AlarmNotificationTypeEnum.ZTimesYMinutesApart:
//                     description = string.Format(
//                         Resources.TieredAlarmingFunctionalityModel.AlarmScheme_TierDescription_NotifyZTimesXMinutesApart,
//                         description,
//                         tier.NotificationCount,
//                         tier.NotificationRepeatMinutes);

//                     break;

//             }

//             return description;

//         }


const AlarmSchemeEditorUtils = {


    mapFormToTierModel: (form: TierFormType): AlarmSchemeTierType => {


        const newTier: AlarmSchemeTierType = {
            id: form.id,
            type: form.type,
            name: form.name,
            delayMinutes: form.delayMinutes,
            repeatCount: form.repeatCount,
            repeatMinutes: form.repeatMinutes,
            repeatCountMinutes: form.repeatCountMinutes,
            repeatZCount: form.repeatZCount,
            description: _formatTierDescription(form),


            // schedules: formTier.schedules.map(o => {
            //     scheduleID: o.;
            //     notificationListID: number;
            
            // } as IEditScheduleDTO)

            //notifications: formTier.notificationLists
            scheduledNotifications: [],
            schedules: [],
            notifications: [],
            useScheduledNotifications: form.useScheduledNotifications
        };



        // id: number,
        // name: string,
    
        // selected: boolean,
        // //notificationLists: NotificationListFormType[]
    
        if (form.useScheduledNotifications) {


            newTier.schedules = form.schedules.flatMap(o => {

                return o.notificationLists.map(v => {
                    return {
                        scheduleID: o.id,
                        notificationListID: v.id,
                    } as IEditScheduleDTO;
                });
            });


            form.schedules.map(o => {


                
                return {
                    scheduleID: o.id,
                    scheduleName: o.name,
                    organizationID: -1, //@@
                    organizationName: '',
                    notifications: o.notificationLists.filter(v => v.selected).map(v => {
                        return {
                            notificationListID: v.id,
                            notificationListName: v.name,
                            organizationID: v.organizationID,
                            organizationName: ''

                        }
                    })
                } as AlarmSchemeScheduledNotificationType
            });


        } else {


            newTier.schedules = form.notificationLists.filter(o => o.selected)
            .map(v => {
                
                return {
                    scheduleID: ALWAYS_SCHEDULE,
                    notificationListID: v.id
                } as IEditScheduleDTO
            })

            newTier.notifications = form.notificationLists.filter(o => o.selected)
            .map(v => {
                return {
                    notificationListID: v.id,
                    notificationListName: v.name,
                    organizationID: v.organizationID,
                    organizationName: ''

                }
            });
        }

        return newTier;

    },
    //mapToTierModel: (alarmScheme: IEditDTO | undefined, referenceData: IReferenceDTO | undefined): AlarmSchemeTierType[] => {
    mapToTierModel: (tiers: IEditTierDTO[] | undefined, referenceData: IReferenceDTO | undefined): AlarmSchemeTierType[] => {

        return tiers?.map(o => {
            const tier: AlarmSchemeTierType = {
                id: o.id,
                type: o.type,
                name: o.name,

                delayMinutes: o.delayMinutes,
                repeatCount: o.repeatCount,
                repeatMinutes: o.repeatMinutes ?? o.repeatCountMinutes,

                repeatZCount: o.repeatZCount,
                        

                description: o.description ?? '',
                schedules: _.cloneDeep(o.schedules),
                notifications: [],
                scheduledNotifications: [],

                useScheduledNotifications: o.schedules.length === 0 || o.schedules.find(o => o.scheduleID === ALWAYS_SCHEDULE) ? false : true
            };
    
            const notificationLists: AlarmSchemeNotificationListType[] = [];
    
            o.schedules.forEach(v => {
    
                const organization = referenceData?.organizations.find(x => x.notificationLists.find(z => z.id === v.notificationListID) !== undefined);
                const notificationList = referenceData?.organizations.flatMap(x => x.notificationLists).find(x => x.id === v.notificationListID);
    
                if (notificationList) {
                    
                    notificationLists.push({
                        notificationListID: notificationList.id,
                        notificationListName: notificationList.name,
                        organizationID: organization?.id ?? -1,
                        organizationName: organization?.name ?? ''
                    } as AlarmSchemeNotificationListType);
                }
            });
    
            tier.notifications = notificationLists;


            tier.scheduledNotifications = Enumerable.from(o.schedules)
                            .groupBy(x => x.scheduleID)
                            .toArray()
                            .map(x => {


                const schedule = referenceData?.schedules.find(v => v.id === x.key());
                const lists = x.toArray();

                return {
    
                    scheduleID: schedule?.id,
                    scheduleName: schedule?.name,
                
                    organizationID: -1, //???@
                    organizationName: '',
                    notifications: lists.map(n => {

                        const notifyList = referenceData?.organizations.flatMap(y => y.notificationLists).find(z => z.id === n.notificationListID)
                        return {
                            notificationListID: n.notificationListID,
                            notificationListName: notifyList?.name
                        } as AlarmSchemeNotificationListType;
        
                    })
                
                } as AlarmSchemeScheduledNotificationType;
    
            });
    
    
            return tier;
        }).sort((a, b) => a.name.localeCompare(b.name)) ?? [];
        
    },
    mapToModel: (formData: AlarmSchemeFormType ): IEditDTO => {

        const model: IEditDTO = {
            id: formData.id,
            name: formData.name,
            tiers: formData.tiers.map(o => {

                return {

                    id: o.id,
                    name: o.name,
                    type: o.type,

                    delayMinutes: o.delayMinutes,
                    repeatMinutes: o.type !== AlarmNotificationTypeEnum.ZTimesYMinutesApart ? o.repeatMinutes : o.repeatCountMinutes ?? o.repeatMinutes,
                    repeatCount: o.type !== AlarmNotificationTypeEnum.ZTimesYMinutesApart ? o.repeatCount : o.repeatZCount ?? o.repeatCount,
                    schedules: [...o.schedules]
                } as IEditTierDTO

            })

        };


        // public toDataTransferObject(): IEditTierDTO {

        //     return <IEditTierDTO>{
    
        //         id: Number(this.id),
    
        //         name: ((this.name !== null) && (this.name.trim().length > 0))
        //             ? this.name.trim()
        //             : null,
    
        //         type: Number(this.notificationType),
    
        //         delayMinutes: DOMUtilities.isNumeric(this.notificationDelayMinutes)
        //             ? Number(this.notificationDelayMinutes)
        //             : null,
    
        //         repeatCount: DOMUtilities.isNumeric(this.notificationRepeatCount)
        //             ? Number(this.notificationRepeatCount)
        //             : null,
    
        //         repeatMinutes: DOMUtilities.isNumeric(this.notificationRepeatMinutes)
        //             ? Number(this.notificationRepeatMinutes)
        //             : null,
    
        //         schedules: Enumerable
        //             .from(this.getScheduledNotifications())
        //             .where(esd => ((esd.scheduleID > 0) && (esd.notificationListID > 0)))
        //             .toArray()
    
        //     };
    
        // }
    

        return model;

    },
    mapToFormValues: (model: IEditDTO, 
        //referenceData: IReferenceDTO,
    ): AlarmSchemeFormType  => {

        const formValues: AlarmSchemeFormType = {...model
        };

        return formValues;
    },

}


export default AlarmSchemeEditorUtils;






